import AddIcon from "@mui/icons-material/Add";
import { Button, Tooltip, useMediaQuery, Zoom } from "@mui/material";
import { Box } from "@mui/material";

const OmniResponsiveButton = props => {
  const {
    tooltipTitle = "Edit",
    tooltipPlacement = "left",
    buttonText = "Add",
    icon = <AddIcon />,
    color = "secondary",
    component,
    children,
    disabled = false,
    varient = "outlined",
  } = props;

  const matches = useMediaQuery(theme => theme.breakpoints.up("md"));

  return (
    <Tooltip
      title={tooltipTitle}
      placement={tooltipPlacement}
      disableInteractive
      enterDelay={500}
      enterNextDelay={500}
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 200, easing: "ease-in-out" }}
      sx={{ ...props.sx }}
    >
      <Button
        startIcon={matches && icon}
        variant={varient}
        color={color}
        onClick={props.onClick}
        component={component}
        disabled={disabled}
      >
        {matches ? <Box sx={{ whiteSpace: "nowrap" }}>{buttonText}</Box> : icon}
        {children}
      </Button>
    </Tooltip>
  );
};

export default OmniResponsiveButton;
